import { ProductTags } from '@app/constants/product-tags.constants';
import { DiscountTypes } from '@app/entities/discount-types';
import { TagType } from '@ux/components/member-rate-tag/entities/tag-type';
import { HotelProvider } from '@hotels/hotel-results/entities/hotel-searched';

export const getHotelTagType =
  (memberRateIndicator: boolean, classTag: ProductTags, hasRappiCard: boolean,
    isPrime: boolean, isLoggedIn: boolean, provider?: string, source?: string): TagType => {
    if ((memberRateIndicator && isLoggedIn) || (classTag?.toLowerCase() === ProductTags.MemberRate)) {
      return showUserTag(hasRappiCard, isPrime, provider, source);
    } else {
      return null;
    }
  }

export const getAutosTagType =
  (preferentialRate: boolean, classTag: ProductTags, hasRappiCard: boolean, isPrime: boolean, isLoggedIn: boolean): TagType => {
    if ((preferentialRate && isLoggedIn) || (classTag?.toLowerCase() === ProductTags.MemberRate)) {
      return showUserTag(hasRappiCard, isPrime);
    } else {
      return null;
    }
  }

export const showUserTag = (hasRappiCard: boolean, isPrime: boolean, provider?: string, source?: string): TagType => {
  const providerIsMarriott = provider?.toLowerCase() === HotelProvider.MarriottBonvoy.toLowerCase();
  const sourceIsPrime = source?.toLowerCase() === DiscountTypes.Prime.toLowerCase();
  const sourceIsRappiCard = source?.toLowerCase() === DiscountTypes.RappiCard.toLowerCase();
  if (providerIsMarriott) {
    return TagType.Marriott;
  } else if (sourceIsPrime) {
    return TagType.PricePrime;
  } else if (sourceIsRappiCard) {
    return TagType.PriceRappiCard;
  }
  return isPrime ? TagType.PricePrime : (hasRappiCard ? TagType.PriceRappiCard : null);
}
